// src/api/db.js

export const API_BASE = "/api"; 

export const api = {
  login: async (username, password) => {
    const res = await fetch(`${API_BASE}/login`, { 
      method: 'POST', 
      headers: { 'Content-Type': 'application/json' }, 
      body: JSON.stringify({ username, password }) 
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error); 
    return data;
  },
  
  register: async (username, password) => {
    const res = await fetch(`${API_BASE}/register`, { 
      method: 'POST', 
      headers: { 'Content-Type': 'application/json' }, 
      body: JSON.stringify({ username, password }) 
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error); 
    return data;
  },
  
  getUserData: async (userId) => {
    const res = await fetch(`${API_BASE}/data/${userId}`);
    if (!res.ok) throw new Error("Failed to load user data"); 
    return await res.json();
  },
  
  syncUserData: async (userId, payload) => {
    await fetch(`${API_BASE}/data/${userId}`, { 
      method: 'POST', 
      headers: { 'Content-Type': 'application/json' }, 
      body: JSON.stringify(payload) 
    });
  },
  
  getUsers: async () => {
    const res = await fetch(`${API_BASE}/users`);
    if (!res.ok) throw new Error("Failed to fetch users"); 
    return await res.json();
  },
  
  deleteUser: async (id) => {
    const res = await fetch(`${API_BASE}/users/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error("Failed to delete user");
  }
};